module.exports = __webpack_public_path__ + "img/mountain-bg.f1c0cd72.jpeg";